import { render } from "./VsudPagination.vue?vue&type=template&id=bc302e40"
import script from "./VsudPagination.vue?vue&type=script&lang=js"
export * from "./VsudPagination.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__